import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
export const documentPackageSummarySectionSchema = z
    .object({
    id: z.string().uuid(),
    category_type: z.string(),
    heading: z.string(),
    body: z.string(),
    finding_ids: z.array(z.number()),
})
    .strict()
    .transform(mapToCamelCase);
export const documentPackageSummarySchema = z
    .object({
    id: z.string().uuid(),
    document_package_id: z.number(),
    description: z.string(),
    created_at: z.string(),
    sections: z.array(documentPackageSummarySectionSchema),
})
    .strict()
    .transform(mapToCamelCase);
// GET /projects/:projectId/packages/:documentPackageId/summary/
export const getDocumentPackageSummaryResponseSchema = z.array(documentPackageSummarySchema);
